// import React, { useState } from "react";

// export default function ({ apiKey }) {
//   const [predictions, setPredictions] = useState([]);
//   const [inputValue, setInputValue] = useState("");

//   const handleInputChange = (event) => {
//     const value = event.target.value;
//     setInputValue(value);

//     if (value.trim() === "") {
//       setPredictions([]);
//       return;
//     }

//     // Fetch predictions from Google Places API
//     const autocompleteService =
//       new window.google.maps.places.AutocompleteService();
//     autocompleteService.getPlacePredictions(
//       {
//         input: value,
//         types: ["(cities)"], // Restrict to cities
//         componentRestrictions: { country: "in" }, // Restrict results to India
//       },
//       (predictions, status) => {
//         if (status === window.google.maps.places.PlacesServiceStatus.OK) {
//           setPredictions(predictions);
//         } else {
//           console.error("Google Places Autocomplete error:", status);
//         }
//       }
//     );
//   };

//   const handleSelectPrediction = (prediction) => {
//     setInputValue(prediction.description);
//     setPredictions([]);
//     // Optionally, you can handle further logic here, like fetching place details
//   };

//   return (
//     <div className="form-group" style={{ position: "relative" }}>
//       <input
//         type="text"
//         value={inputValue}
//         onChange={handleInputChange}
//         placeholder="Enter a location..."
//         className="form-control"
//       />
//       {predictions.length > 0 && (
//         <div
//           className="predictions-list bg-light px-3 py-2"
//           style={{
//             position: "absolute",
//             zIndex: 99,
//             left: 0,
//             right: 0,
//             boxShadow: "rgba(0, 0, 0, 0.5) 0px 1px 5px 0px",
//           }}
//         >
//           {predictions.map((prediction) => (
//             <div
//               className="py-2 border-bottom"
//               key={prediction.place_id}
//               onClick={() => handleSelectPrediction(prediction)}
//             >
//               {prediction.description}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useRef, useEffect } from "react";

export default function ({
  myApiKey,
  handleOnChange,
  inputValuee = false,
  inputValue,
  setInputValue,
}) {
  const [predictions, setPredictions] = useState([]);
  // const [inputValue, setInputValue] = useState("");
  const inputRef = useRef();

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (value.trim() === "") {
      setPredictions([]);
      return;
    }

    // Fetch predictions from Google Places API
    const autocompleteService =
      new window.google.maps.places.AutocompleteService();
    autocompleteService.getPlacePredictions(
      {
        input: value,
        // types: ["(cities)"],
        componentRestrictions: { country: ["in"] },
      },
      (predictions, status) => {
        console.log("status", status);
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          setPredictions(predictions);
        } else if (
          status === window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS
        ) {
          // setPredictions([]);
          console.log("status of places", status);
        } else {
          console.error("Google Places Autocomplete error:", status);
        }
        // if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        //   setPredictions(predictions);
        // } else if (
        //   status === window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS
        // ) {
        //   setPredictions([]);
        // } else {
        //   console.error("Google Places Autocomplete error:", status);
        // }
      }
    );
  };

  const handleSelectPrediction = (prediction) => {
    setInputValue(prediction.description);
    setPredictions([]);
    if (handleOnChange) {
      handleOnChange(prediction); // Callback to parent component with selected prediction
    }
  };

  useEffect(() => {
    if (inputValuee == true) {
      setInputValue("");
    }
  }, [inputValuee]);

  return (
    <div className="form-group" style={{ position: "relative" }}>
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Enter a location..."
        className="form-control"
      />
      {predictions.length > 0 && (
        <div
          className="predictions-list bg-light px-3 py-2"
          style={{
            position: "absolute",
            zIndex: 99,
            left: 0,
            right: 0,
            boxShadow: "rgba(0, 0, 0, 0.5) 0px 1px 5px 0px",
          }}
        >
          {predictions.map((prediction) => (
            <div
              className="py-2 border-bottom"
              key={prediction.place_id}
              onClick={() => handleSelectPrediction(prediction)}
            >
              {prediction.description}
            </div>
          ))}
        </div>
      )}
    </div>

    // <div className="form-group" style={{ position: "relative" }}>
    //   <input
    //     type="text"
    //     value={inputValue}
    //     onChange={handleInputChange}
    //     placeholder="Enter a location..."
    //     className="form-control"
    //     ref={inputRef}
    //   />
    //   {predictions.length > 0 && (
    //     <ul
    //       className="predictions-list"
    //       style={{ position: "absolute", top: 90 }}
    //     >
    //       {predictions.map((prediction) => (
    //         <li
    //           key={prediction.place_id}
    //           onClick={() => handleSelectPrediction(prediction)}
    //         >
    //           {prediction.description}
    //         </li>
    //       ))}
    //     </ul>
    //   )}

    // </div>
  );
}
